export default __webpack_public_path__ + "static/bunfestival-6-6676a9295889e23237fe9a512d82b508.png";